import { useQuery } from "@tanstack/react-query";
import { getCountries } from "./requests";
import type { Country } from "../types";

export const useGetCountries = () => {
  return useQuery({
    queryKey: ['get-countries'],
    queryFn: (): Promise<Country[]> => getCountries(),
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
    gcTime: 1000 * 60 * 60 * 24, // 24 hours
  });
};